module.exports = __webpack_public_path__ + "static/stairascent_walk_l-90704a10b7762f04de50cddd95cfede2.jpg";